/**
 * Studio-aware example prompts shown on the blank document so a first-time
 * writer has a one-click way to start. Clicking a chip switches to the
 * Generate operation and seeds its prompt (via the panel's promptSeed channel).
 *
 * Keyed by studioId; falls back to a generic set.
 */
const EXAMPLES_BY_STUDIO: Record<string, string[]> = {
  storyteller: [
    'A detective wakes to find the city has forgotten her name',
    'Two rivals are stranded together on the last train out',
    'A lighthouse keeper receives a letter dated fifty years from now',
  ],
  journalist: [
    'Explainer: why local water bills suddenly doubled this year',
    'Profile of a night-shift nurse keeping a rural ER open',
    'Investigative lede: where did the redevelopment funds go?',
  ],
  blogger: [
    '5 underrated productivity habits that actually stuck',
    'How I cut my grocery bill by 30% without coupons',
    'A beginner-friendly guide to starting a vegetable garden',
  ],
  influencer: [
    'Launch caption for a new sustainable sneaker drop',
    'Behind-the-scenes hook for a studio tour reel',
    'Engagement post: this or that — coffee vs. matcha',
  ],
};

const DEFAULT_EXAMPLES = [
  'Write an opening paragraph that hooks the reader immediately',
  'Draft a short, punchy introduction on a topic of your choice',
  'Begin a piece with a vivid, specific scene',
];

export function writerExamplePromptsForStudio(studioId: string | undefined): string[] {
  if (!studioId) return DEFAULT_EXAMPLES;
  return EXAMPLES_BY_STUDIO[studioId] ?? DEFAULT_EXAMPLES;
}
